import { createContext } from 'react';

import { AlignmentReference } from 'editor/src/store/design/operation/align/alignSelectedMediaOperation';

const AlignmentReferenceContext = createContext<AlignmentReference>('page');

export default AlignmentReferenceContext;
